var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import "../theme/styles.css";
import de from "date-fns/locale/de";
import { Button, CrossIcon, Dialog, Heading, InfoSignIcon, Label, Pane, SelectMenu, toaster, Tooltip, } from "evergreen-ui";
import "firebase/auth";
import "firebase/firestore";
import moment from "moment";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import firebase from "../config";
import { LocationContext } from "../contexts/LocationContext";
import { usePlan } from "../hooks/usePlan";
import { createNewTask } from "../utility/createNewTask";
import BlueBar from "./BlueBar";
//New theme
import { ThemeContext } from "evergreen-ui";
import { UserContext } from "../contexts/UserContext";
import theme from "../theme";
import endpoint from "../utility/endpoint";
import { normaliseMoneyString } from "../utility/normaliseMoneyString";
import { useSetFlag } from "../utility/use-set-flag";
import { createId } from "../utility/utility";
import ApoLocationInput from "./ApoLocationInput";
import ApoSegmentedControl from "./ApoSegmentedControl";
import ApoSelect from "./ApoSelect";
import ApoTextInput from "./ApoTextInput";
import DurationField from "./DurationField";
import TagSelectMenu from "./TagSelectMenu";
var ThemeProvider = ThemeContext.Provider;
registerLocale("de", de);
var taskTypeOptions = [
    { label: "Lieferung", value: "delivery" },
    { label: "Abholung", value: "pickup" },
];
var findBusiness = function (locations, businessId) {
    return locations.filter(function (location) { return location.id === businessId; })[0];
};
function TaskCheckDialog(props) {
    var _this = this;
    var _a, _b, _c;
    var mergeTasks = useMemo(function () { return (props === null || props === void 0 ? void 0 : props.tasks) && (props === null || props === void 0 ? void 0 : props.tasks.length) > 0; }, [props.tasks]);
    var _d = useContext(UserContext), user = _d.user, ready = _d.ready;
    var isUser = user[0];
    var _e = useState(false), isLoading = _e[0], setLoading = _e[1];
    var businessLocations = useContext(LocationContext).availableLocations;
    var _f = useState(props.task ? props.task.task_origin : (_a = businessLocations[0]) === null || _a === void 0 ? void 0 : _a.id), selectedBusinessId = _f[0], setSelectedBusinessId = _f[1];
    var _g = useState(props.task ? props.task.task_tags : []), taskTags = _g[0], setTaskTags = _g[1];
    var _h = useState(props.task ? props.task.task_type : taskTypeOptions[0].value), taskType = _h[0], setTaskType = _h[1];
    var _j = useState(props.task ? props.task.customer_name : ""), customerName = _j[0], setCustomerName = _j[1];
    var _k = useState(props.task ? props.task.customer_mail : ""), customerEmail = _k[0], setCustomerEmail = _k[1];
    var _l = useState(props.task ? props.task.customer_phone : ""), customerPhone = _l[0], setCustomerPhone = _l[1];
    var _m = useState(""), startDate = _m[0], setStartDate = _m[1];
    var _o = useState(props.task
        ? normaliseMoneyString(props.task.task_open_amount).replace("€", "")
        : 0), openAmount = _o[0], setOpenAmount = _o[1];
    var _p = useState(props.task ? props.task.task_earliest : ""), earliest = _p[0], setEarliest = _p[1];
    var _q = useState(props.task ? props.task.task_latest : ""), latest = _q[0], setLatest = _q[1];
    var _r = useState(props.task ? props.task.task_process_time : null), processTime = _r[0], setProcessTime = _r[1];
    var _s = useState(props.task ? props.task.task_note : null), taskNote = _s[0], setTaskNote = _s[1];
    // 1 -> Max, 3 -> Medium, null -> Unset, 20 -> None
    var _t = useState(props.task ? props.task.task_priority : null), selectedPrio = _t[0], setSelectedPrio = _t[1];
    var _u = useState(), selected = _u[0], setSelected = _u[1];
    var _v = useState([]), areFavs = _v[0], setFavs = _v[1];
    var _w = useState(false), isFav = _w[0], setFav = _w[1];
    var _x = useState(false), isFavEditMode = _x[0], setFavEditMode = _x[1];
    var _y = useState(), isFavCurrName = _y[0], setFavCurrName = _y[1];
    var checkOrderCreated = useSetFlag().checkOrderCreated;
    var plan = usePlan();
    function compareTimeWindow(earliestTime, latestTime) {
        if (!earliestTime && !latestTime)
            return false;
        var _a = earliestTime.split(":").map(Number), hour1 = _a[0], minute1 = _a[1];
        var _b = latestTime.split(":").map(Number), hour2 = _b[0], minute2 = _b[1];
        if (earliestTime === "" || latestTime === "")
            return false;
        if (hour1 < hour2) {
            return false;
        }
        else if (hour1 > hour2) {
            return true;
        }
        else {
            if (minute1 < minute2) {
                return false;
            }
            else if (minute1 > minute2) {
                return true;
            }
            else {
                return true;
            }
        }
    }
    useEffect(function () {
        getFavorites();
    }, []);
    function getFavorites() {
        firebase
            .firestore()
            .collection("favorites")
            .where("owner", "==", firebase.auth().currentUser.uid)
            .get()
            .then(function (snap) {
            var favs = [];
            snap.forEach(function (doc) {
                var data = doc.data();
                var obj = { label: data.name, value: data };
                favs.push(obj);
            });
            setFavs(favs);
        });
    }
    var prios = useState([
        { label: "Keine", value: 20 },
        { label: "!!!", value: 1 },
    ])[0];
    var _z = useState(props.task
        ? {
            address: props.task.task_address,
            coords: props.task.task_coords,
        }
        : null), taskLocation = _z[0], setTaskLocation = _z[1];
    var businessLocationOptions = useMemo(function () {
        return (businessLocations || [])
            .filter(function (l) { return !l.archived; })
            .map(function (l) { return ({ label: l.name, value: l.id }); });
    }, [businessLocations]);
    var sendTrackingMail = function (name, mail, id) { return __awaiter(_this, void 0, void 0, function () {
        var rawResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!mail || mail === "" || !isUser.trackingNotifications) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, fetch("https://".concat(endpoint(), ".cloudfunctions.net/api/sendTrackingMail"), {
                            method: "POST",
                            headers: {
                                Accept: "application/json",
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({ id: id, email: mail, firstName: name }),
                        })];
                case 1:
                    rawResponse = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    function addNewTask(close) {
        return __awaiter(this, void 0, void 0, function () {
            var checkTimeWindow, responsibleBusiness, taskObj;
            return __generator(this, function (_a) {
                setLoading(true);
                if (!customerName) {
                    toaster.notify("Sie müssen den Namen des Kunden angeben!");
                    setLoading(false);
                    return [2 /*return*/];
                }
                if (!taskLocation) {
                    toaster.notify("Bitte geben Sie die Addresse des Auftrages an!");
                    setLoading(false);
                    return [2 /*return*/];
                }
                checkTimeWindow = compareTimeWindow(earliest, latest);
                if (checkTimeWindow) {
                    toaster.danger("Fehler mit dem Zeitfenster. Frühester Zeitpunkt darf nicht nach dem spätesten Zeitpunkt liegen oder gleich mit ihm sein.");
                    return [2 /*return*/];
                }
                responsibleBusiness = selectedBusinessId
                    ? findBusiness(businessLocations, selectedBusinessId)
                    : businessLocations[0];
                checkOrderCreated();
                taskObj = createNewTask(customerName, customerEmail, customerPhone, taskType, typeof startDate === "string"
                    ? moment(startDate, "YYYY-MM-DD").toDate()
                    : startDate, earliest, latest, selectedPrio ? parseInt(selectedPrio) : null, processTime, taskNote, taskLocation.address, taskLocation.coords, openAmount.toString().replace(",", "."), responsibleBusiness !== null && responsibleBusiness !== void 0 ? responsibleBusiness : businessLocations[0], firebase.auth().currentUser.uid, "Manuell", null, null, null, null, taskTags);
                firebase
                    .firestore()
                    .collection("tasks")
                    .doc(taskObj.task_id)
                    .set(taskObj)
                    .then(function () {
                    toaster.success("Neuer Auftrag wurde angelegt");
                    sendTrackingMail(customerName, customerEmail, taskObj.task_id);
                    if (close) {
                        props.setShown(false);
                        setLoading(false);
                    }
                    else {
                        setLoading(false);
                    }
                })
                    .catch(function () {
                    setLoading(false);
                });
                return [2 /*return*/];
            });
        });
    }
    function saveChangesToTask() {
        return __awaiter(this, void 0, void 0, function () {
            var newStartDate, responsibleBusiness, checkTimeWindow;
            return __generator(this, function (_a) {
                setLoading(true);
                newStartDate = startDate;
                responsibleBusiness = selectedBusinessId
                    ? findBusiness(businessLocations, selectedBusinessId)
                    : businessLocations[0];
                checkTimeWindow = compareTimeWindow(earliest, latest);
                if (checkTimeWindow) {
                    toaster.danger("Fehler mit dem Zeitfenster. Frühester Zeitpunkt darf nicht nach dem spätesten Zeitpunkt liegen oder gleich mit ihm sein.");
                    return [2 /*return*/];
                }
                if (typeof newStartDate === "string") {
                    newStartDate = moment(startDate, "YYYY-MM-DD").toDate();
                }
                firebase
                    .firestore()
                    .collection("tasks")
                    .doc(props.task.task_id)
                    .update({
                    customer_mail: customerEmail,
                    customer_name: customerName,
                    customer_phone: customerPhone,
                    task_address: taskLocation.address,
                    task_coords: taskLocation.coords,
                    task_date: newStartDate,
                    task_earliest: earliest,
                    task_latest: latest,
                    task_note: taskNote,
                    task_open_amount: openAmount.toString().replace(",", "."),
                    task_origin: responsibleBusiness.id,
                    task_origin_coords: responsibleBusiness.coords,
                    task_priority: selectedPrio ? parseInt(selectedPrio) : null,
                    task_process_time: processTime,
                    task_type: taskType,
                    task_tags: taskTags,
                })
                    .then(function () {
                    setLoading(false);
                    props.setShown(false);
                    toaster.notify("Änderungen erfolgreich gespeichert");
                });
                return [2 /*return*/];
            });
        });
    }
    var handleStartDateChange = useCallback(function (e) { return setStartDate(new Date(e.target.value)); }, []);
    var handleNameChange = useCallback(function (e) {
        var isInFav = areFavs.filter(function (fav) { return fav.label === e.target.value; });
        if (isInFav.length !== 0) {
            toaster.notify("Sie haben diesen Nutzer unter den Favoriten gespeichert!", {
                description: "Um den Favoriten zu bearbeiten, klicken sie unten auf den blauen Knopf 'Favorit bearbeiten'",
            });
            setFav(true);
        }
        else {
            setFav(false);
        }
        setCustomerName(e.target.value);
    }, [areFavs, setFav, isFav]);
    var handlePhoneChange = useCallback(function (e) { return setCustomerPhone(e.target.value); }, []);
    var handleEmailChange = useCallback(function (e) { return setCustomerEmail(e.target.value); }, []);
    var handleAddressChange = useCallback(function (loc) {
        setTaskLocation(loc);
    }, []);
    var handleTaskTypeChange = useCallback(setTaskType, []);
    var handleBusinessChange = useCallback(function (e) { return setSelectedBusinessId(e.target.value); }, []);
    var handleOpenAmountChange = useCallback(function (e) { return setOpenAmount(e.target.value); }, []);
    var handleEarliestChange = useCallback(function (e) { return setEarliest(e.target.value); }, []);
    var handleLatestChange = useCallback(function (e) { return setLatest(e.target.value); }, []);
    var handlePriorityChange = useCallback(setSelectedPrio, [setSelectedPrio]);
    var handleProcessTimeChange = useCallback(setProcessTime, [setProcessTime]);
    var handleNoteChange = useCallback(function (e) { return setTaskNote(e.target.value); }, []);
    var _0 = useState(0), locationResetNumber = _0[0], setLocationResetNumber = _0[1]; // ToDo: Fix this!!!
    var handleSaveAndContinueClick = useCallback(function () {
        var _a;
        addNewTask(false);
        setSelectedBusinessId((_a = businessLocations[0]) === null || _a === void 0 ? void 0 : _a.id);
        setTaskTags([]);
        setTaskType(taskTypeOptions[0].value);
        setCustomerName("");
        setCustomerEmail("");
        setCustomerPhone("");
        setStartDate(new Date());
        setOpenAmount(0);
        setEarliest("");
        setLatest("");
        setProcessTime(0);
        setTaskNote(null);
        setSelectedPrio(null);
        setFav(false);
        setFavEditMode(false);
        setFavCurrName(undefined);
        setTaskLocation(null);
        setLocationResetNumber(locationResetNumber + 1);
    }, [addNewTask, businessLocations, locationResetNumber]);
    var handleSaveClick = useCallback(function () {
        props.edit ? saveChangesToTask() : addNewTask(true);
    }, [props.edit, saveChangesToTask, addNewTask]);
    var handleCloseClick = useCallback(function () {
        props.setShown(false);
    }, [props]);
    function selectFavorite(item) {
        var _a, _b;
        setFav(true);
        setCustomerName(item.value.name);
        setCustomerPhone(item.value.phone);
        setCustomerEmail(item.value.mail);
        setTaskLocation({
            address: item.value.location.address,
            coords: item.value.location.coords,
        });
        setTaskType(item.value.type);
        setEarliest(item.value.earliest);
        setLatest(item.value.latest);
        setProcessTime(item.value.processTime);
        setTaskNote(item.value.note);
        setSelectedBusinessId(item.value.origin);
        setSelectedPrio((_b = (_a = item.value) === null || _a === void 0 ? void 0 : _a.priority) !== null && _b !== void 0 ? _b : null);
        toaster.success("Favorit wurde ausgewählt!");
    }
    var saveAsFav = function () {
        if (!customerName) {
            toaster.notify("Sie müssen den Namen des Kunden angeben!");
            setLoading(false);
            return;
        }
        if (!taskLocation) {
            toaster.notify("Bitte geben Sie die Addresse des Auftrages an!");
            setLoading(false);
            return;
        }
        var responsibleBusiness = selectedBusinessId
            ? findBusiness(businessLocations, selectedBusinessId)
            : businessLocations[0];
        var uid = createId();
        firebase
            .firestore()
            .collection("favorites")
            .doc(uid)
            .set({
            name: customerName,
            phone: customerPhone !== null && customerPhone !== void 0 ? customerPhone : "",
            mail: customerEmail !== null && customerEmail !== void 0 ? customerEmail : "",
            type: taskType,
            note: taskNote !== null && taskNote !== void 0 ? taskNote : null,
            location: {
                address: taskLocation.address,
                coords: taskLocation.coords,
            },
            earliest: earliest !== null && earliest !== void 0 ? earliest : "",
            latest: latest !== null && latest !== void 0 ? latest : "",
            processTime: processTime !== null && processTime !== void 0 ? processTime : null,
            origin: responsibleBusiness.id,
            owner: firebase.auth().currentUser.uid,
            uid: uid !== null && uid !== void 0 ? uid : null,
        })
            .then(function () {
            toaster.success("Ein neuer Favorit wurde angelegt");
        })
            .catch(function () {
            toaster.notify("Der Favorit konnte nicht angelegt werden");
        });
    };
    var disabled = useMemo(function () {
        var _a, _b, _c, _d, _e;
        return props.task
            ? ((_a = props.task) === null || _a === void 0 ? void 0 : _a.task_status) !== "unassigned" &&
                ((_b = props.task) === null || _b === void 0 ? void 0 : _b.task_status) !== "prepared" &&
                ((_c = props.task) === null || _c === void 0 ? void 0 : _c.task_status) !== "attached" &&
                ((_d = props.task) === null || _d === void 0 ? void 0 : _d.task_status) !== "assigned" &&
                ((_e = props.task) === null || _e === void 0 ? void 0 : _e.task_status) !== "error"
            : false;
    }, [props.task]);
    useEffect(function () {
        var formatTaskDate = function (task) {
            var newTaskDate;
            if ((task === null || task === void 0 ? void 0 : task.task_date.nanoseconds) > 0) {
                newTaskDate = moment
                    .unix((task === null || task === void 0 ? void 0 : task.task_date.seconds) + (task === null || task === void 0 ? void 0 : task.task_date.nanoseconds) / 1000000000)
                    .format("YYYY-MM-DD");
            }
            else {
                newTaskDate = moment
                    .unix((task === null || task === void 0 ? void 0 : task.task_date.seconds) + 0)
                    .format("YYYY-MM-DD");
            }
            return newTaskDate;
        };
        if (props.task) {
            setStartDate(moment(formatTaskDate(props.task)).format("YYYY-MM-DD"));
        }
        else {
            // If this is a new task, pre-fill the field with the current date
            setStartDate(moment().format("YYYY-MM-DD"));
        }
    }, [props.task]);
    var handleMergeTasks = function (close) {
        if (!customerName) {
            toaster.notify("Sie müssen den Namen des Kunden angeben!");
            setLoading(false);
            return;
        }
        setLoading(true);
        var responsibleBusiness = selectedBusinessId
            ? findBusiness(businessLocations, selectedBusinessId)
            : businessLocations[0];
        var parentTask = createNewTask(customerName, customerEmail, customerPhone, taskType, typeof startDate === "string"
            ? moment(startDate, "YYYY-MM-DD").toDate()
            : startDate, earliest, latest, selectedPrio ? parseInt(selectedPrio) : null, processTime, taskNote, taskLocation.address, taskLocation.coords, openAmount.toString().replace(",", "."), responsibleBusiness, firebase.auth().currentUser.uid, "Manuell", null, null, null, null, taskTags);
        var tasksToGroup = props.tasks.map(function (task) { return task.task_id; });
        firebase
            .firestore()
            .collection("tasks")
            .doc(parentTask.task_id)
            .set(__assign(__assign({}, parentTask), { taskIds: tasksToGroup, collectiveTask: true }))
            .then(function () {
            tasksToGroup.forEach(function (taskId) {
                firebase
                    .firestore()
                    .collection("tasks")
                    .doc(taskId)
                    .update({ isMerged: true, parent_task: parentTask.task_id });
            });
        })
            .then(function () {
            toaster.success("".concat(props.tasks.length, " Auftr\u00E4ge wurden zusammengefasst!"));
            sendTrackingMail(customerName, customerEmail, parentTask.task_id);
            if (close) {
                props.setShown(false);
                setLoading(false);
            }
            else {
                setLoading(false);
            }
        })
            .catch(function () {
            setLoading(false);
        });
    };
    return (_jsx(ThemeProvider, __assign({ value: theme }, { children: _jsxs(Dialog, __assign({ isShown: props.isShown, cancelLabel: "Abbrechen", confirmLabel: "Hinzuf\u00FCgen", shouldCloseOnOverlayClick: false, shouldCloseOnEscapePress: false, hasHeader: false, hasFooter: false, contentContainerProps: {
                className: "dialog-content-container",
                padding: 0,
            }, containerProps: { className: "square-corners" }, width: "80vw" }, { children: [_jsx(BlueBar, {}), _jsx(CrossIcon, { onClick: handleCloseClick, style: {
                        position: "absolute",
                        right: 20,
                        top: 20,
                        cursor: "pointer",
                    } }), _jsxs(Pane, __assign({ display: "flex" }, { children: [_jsxs(Pane, __assign({ style: {
                                width: "49.5%",
                                padding: 20,
                                paddingBottom: 0,
                            } }, { children: [_jsx(Heading, __assign({ size: "large", marginBottom: 20 }, { children: mergeTasks
                                        ? "Sammelauftrag erstellen (".concat(props.tasks.length, " Auftr\u00E4ge ausgew\u00E4hlt)")
                                        : props.edit
                                            ? "AUFTRAG BEARBEITEN"
                                            : "AUFTRAG HINZUFÜGEN" })), _jsxs("div", __assign({ style: {
                                        display: "flex",
                                        width: "100%",
                                    } }, { children: [(plan === null || plan === void 0 ? void 0 : plan.subscriptionLabel) === "apomap-lite" ? (_jsxs("div", __assign({ style: {
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                alignItems: "flex-start",
                                                gap: 0,
                                                marginRight: "0.5rem",
                                            } }, { children: [_jsx(Button, __assign({ disabled: true }, { children: selected || "⭐️ Aus Favoriten auswählen" })), _jsx("p", __assign({ style: {
                                                        marginTop: "0.1rem",
                                                        fontStyle: "italic",
                                                        fontSize: "0.8rem",
                                                        color: "#b20000",
                                                    } }, { children: "Im Plus & Pro Plan verf\u00FCgbar" }))] }))) : (_jsx(SelectMenu, __assign({ closeOnSelect: true, title: "Favoritenliste", options: areFavs.map(function (obj) { return ({
                                                label: obj.label,
                                                value: obj.value,
                                            }); }), selected: selected, onSelect: function (item) { return selectFavorite(item); } }, { children: _jsx(Button, __assign({ style: { marginRight: "0.5rem", cursor: "pointer" } }, { children: selected || "⭐️ Aus Favoriten auswählen" })) }))), _jsx(TagSelectMenu, { value: taskTags !== null && taskTags !== void 0 ? taskTags : [], onChange: function (value) { return setTaskTags(value); } })] }))] })), _jsx(Pane, { style: {
                                flex: 1,
                                padding: 20,
                                backgroundColor: "#F9FAFC",
                            } })] })), _jsxs(Pane, __assign({ display: "flex", overflow: "scroll", flex: 1 }, { children: [_jsxs(Pane, __assign({ style: {
                                width: "50%",
                                padding: 20,
                            } }, { children: [_jsxs(Pane, __assign({ className: "spaced-h-12-flx1", display: "flex", flexDirection: "row" }, { children: [_jsx(ApoTextInput, { disabled: disabled, label: "Name", required: true, placeholder: "Max Mustermann", value: customerName, onChange: handleNameChange }), _jsx(ApoTextInput, { disabled: disabled, label: "Telefonnummer", 
                                            // required
                                            placeholder: "0800/666666", type: "tel", value: customerPhone, onChange: handlePhoneChange }), _jsx(ApoTextInput, { disabled: disabled, label: "E-Mail Adresse", value: customerEmail, type: "email", placeholder: "mustermann@mail.de", onChange: handleEmailChange })] })), _jsx(Pane, __assign({ className: "spaced-h-12-flx1", display: "flex", flexDirection: "row" }, { children: _jsx(ApoLocationInput, { disabled: disabled, label: taskType === "delivery" ? "Lieferadresse" : "Abholadresse", required: true, defaultValue: taskLocation, onChange: handleAddressChange, resetNumber: locationResetNumber, placeholder: "Adresse hier..." }) }))] })), _jsxs(Pane, __assign({ style: {
                                width: "50%",
                                padding: 10,
                                backgroundColor: "#F9FAFC",
                                height: "fit-content",
                            } }, { children: [_jsxs(Pane, __assign({ display: "flex", flexDirection: "row" }, { children: [_jsxs(Pane, __assign({ width: "50%", padding: 10, paddingBottom: 0, display: "flex", flexDirection: "column" }, { children: [_jsx(ApoSegmentedControl, { disabled: disabled, required: true, label: "Art", value: taskType, options: taskTypeOptions, onChange: handleTaskTypeChange }), _jsxs(Pane, __assign({ className: "spaced-h-12-flx1", display: "flex", flexDirection: "row" }, { children: [_jsxs(Pane, __assign({ display: "flex" }, { children: [_jsx(ApoTextInput, { label: "Betrag (\u20AC)", required: true, value: openAmount, onChange: handleOpenAmountChange, marginRight: "5px", maxWidth: 100 }), _jsx(Tooltip, __assign({ content: "Bei Betr\u00E4gen \u00FCber 1000 Euro bitte keine tausender Trennzeichen verwenden! nicht -> 1.000,99 sondern -> 1000,99" }, { children: _jsx(InfoSignIcon, {}) }))] })), _jsx(ApoTextInput, { disabled: disabled, label: "Datum", required: true, type: "date", value: moment(startDate).format("YYYY-MM-DD"), numberProps: { min: moment().format("YYYY-MM-DD") }, onChange: handleStartDateChange, maxWidth: 120, marginLeft: "5px", borderRadius: "0px" })] })), _jsx(Pane, { children: _jsx(ApoSegmentedControl, { disabled: disabled, label: _jsx(Tooltip, __assign({ content: "Wenn die Lieferung als Eillieferung gilt, w\u00E4hle eine Priorit\u00E4t. Der Auftrag wird dann innerhalb der ersten 30 Minuten ausgefahren." }, { children: _jsxs(Pane, __assign({ style: { display: "flex", flexDirection: "row" } }, { children: [_jsx(Label, __assign({ fontSize: "15px", fontWeight: 400, display: "block" }, { children: "Priorit\u00E4ten" })), _jsx(InfoSignIcon, { marginLeft: 5 })] })) })), options: prios, value: selectedPrio ? selectedPrio.toString() : "20", onChange: handlePriorityChange }) })] })), _jsxs(Pane, __assign({ width: "50%", padding: 10, paddingBottom: 0, display: "flex", flexDirection: "column" }, { children: [_jsx(ApoSelect, { disabled: disabled, required: true, label: "Apotheke", options: businessLocationOptions, value: selectedBusinessId, onChange: handleBusinessChange }), _jsxs(Pane, __assign({ className: "spaced-h-12-flx1", display: "flex", flexDirection: "row" }, { children: [_jsx(ApoTextInput, { disabled: disabled && ((_b = props === null || props === void 0 ? void 0 : props.task) === null || _b === void 0 ? void 0 : _b.task_status) !== "prepared", label: "Ab", value: earliest, type: "time", onChange: handleEarliestChange, marginRight: "5px", marginBottom: "13px", borderRadius: "0px" }), _jsx(ApoTextInput, { disabled: disabled && ((_c = props === null || props === void 0 ? void 0 : props.task) === null || _c === void 0 ? void 0 : _c.task_status) !== "prepared", label: "Bis", value: latest, type: "time", onChange: handleLatestChange, marginLeft: "5px", marginBottom: "13px", width: "90%", borderRadius: "0px" })] })), _jsx(Pane, __assign({ style: { width: "100%" } }, { children: _jsx(DurationField, { disabled: disabled, label: "Aufenthalt", value: processTime, onChange: handleProcessTimeChange }) }))] }))] })), _jsx(Pane, __assign({ padding: 10, paddingTop: 0 }, { children: _jsx(ApoTextInput, { label: "Hinweis an den Fahrer", value: taskNote, isTextarea: true, minHeight: 100, onChange: handleNoteChange, borderRadius: "0px" }) }))] }))] })), _jsxs(Pane, __assign({ style: { display: "flex", padding: 20, flex: 1 }, className: "spaced-h-30" }, { children: [_jsx(Button, __assign({ size: "large", style: { marginRight: "auto" }, appearance: "primary", onClick: handleCloseClick }, { children: "Abbrechen" })), (plan === null || plan === void 0 ? void 0 : plan.subscriptionLabel) === "apomap-lite" ? (_jsx(Button, __assign({ size: "large", intent: "success", onClick: saveAsFav, disabled: true }, { children: "Als Favorit speichern" }))) : (_jsx(Button, __assign({ size: "large", intent: "success", onClick: saveAsFav }, { children: "Als Favorit speichern" }))), !props.edit && (_jsx(Button, __assign({ size: "large", intent: "success", onClick: handleSaveAndContinueClick }, { children: "Speichern & Weiteren hinzuf\u00FCgen" }))), _jsx(Button, __assign({ size: "large", intent: "success", appearance: "primary", onClick: mergeTasks ? handleMergeTasks : handleSaveClick }, { children: mergeTasks ? "Erstellen" : "Speichern" }))] }))] })) })));
}
export default function TaskDialog(props) {
    if (!props.isShown) {
        return null;
    }
    else {
        return _jsx(TaskCheckDialog, __assign({}, props));
    }
}
